import { render, staticRenderFns } from "./DescriptionQuality.htm?vue&type=template&id=b87b7b2c&scoped=true&"
import script from "./DescriptionQuality.ts?vue&type=script&lang=js&"
export * from "./DescriptionQuality.ts?vue&type=script&lang=js&"
import style0 from "./DescriptionQuality.scss?vue&type=style&index=0&id=b87b7b2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87b7b2c",
  null
  
)

export default component.exports